<template>
  <v-dialog
    v-model="isChannelIconSetting"
    width="380px"
    :before-close="close"
    :modal-append-to-body="false"
    @click:outside="close"
  >
    <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-4 py-5">
      <span class="txt-dialog-title ml-2">{{ $t('channelIconSettingTitle') }}</span>
      <!-- <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn> -->
    </v-row>
    <v-row no-gutters style="background-color: #21343b; font-size: 14px" class="px-6" align="center" justify="center">
      <v-col cols="4">
        <v-avatar class="logo" round size="50" style="cursor: pointer">
          <v-img :src="chLogo" v-if="chLogo" />
          <div class="avatar-bg" v-else>
            <span class="material-icons-round" translate="no" style="font-size: 22px; color: #bbb; margin-top: -3px">
              add_a_photo
            </span>
          </div>
        </v-avatar>
      </v-col>
      <v-col cols="8" style="display: flex; justify-content: flex-end">
        <v-btn
          elevation="0"
          dark
          width="40%"
          style="display: inline-block"
          class="btn-small"
          :disabled="!chLogo"
          @click="deleteChLogo"
        >
          {{ 'Delete' }}
        </v-btn>
        <div class="filebox ml-2">
          <label for="logo">{{ $t('upload') }}</label>
          <input accept=".png,.jpg,.jpeg" type="file" id="logo" @change="setChLogo" />
        </div>
        <!-- <v-btn dark width="40%" style="display: inline-block" class="btn-small btn-upload ml-3"> -->
        <!-- </v-btn> -->
      </v-col>
    </v-row>
    <v-row no-gutters justify="space-between" style="background-color: #21343b; margin: 0 !important" class="px-6 py-5">
      <v-col class="container-copy-url" cols="12" align="center">
        <v-btn
          dark
          :disabled="!isChLogoChanged"
          :loading="isLoading"
          color="rgb(40, 144, 103)"
          width="100%"
          @click="setChLogoUpload()"
        >
          {{ 'Done' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { isMobile, isSafari } from '@/common/lib/strLib'
import { setFileUpload, setInvalidCache } from '@/services/api'
import { setChannelDetail } from '@/services/channelApi'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'

export default {
  name: 'ChannelIconSetting',
  props: { isChannelIconSetting: Boolean },
  data() {
    return {
      chLogo: null,
      isChLogoChanged: false,
      isLoading: false,
      errorCode: '',
      errorMessage: '',
    }
  },
  created() {
    this.chLogo = this.selectedCh['chLogo']
  },
  methods: {
    close() {
      this.$emit('close', 'ChannelIcon')
    },
    async setChLogoUpload() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      if (this.isChLogoChanged) await this.uploadS3()

      try {
        let result = await setChannelDetail(
          this,
          this.userInfo.userId,
          this.selectedWsInfo.wsId,
          this.selectedCh['chType'],
          this.chId,
          this.selectedCh['chTitle'],
          this.selectedCh['chDescription'],
          this.selectedCh['receivingStatus'],
          this.chLogo ? `https://file.tape.ooo/chLogo/${this.chId}.png` : ''
        )
        this.$emit('changedChLogo', result)
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        this.close()
      } catch (error) {
        this.errorCode = error.response.status
        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))
      }

      if (this.isChLogoChanged && (!this.errorMessage || this.errorMessage === '')) {
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        this.isLoading = false
        // location.reload()
      } else {
        // notify(this, 'Error', this.$t('updateFail') + this.errorMessage, 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateFail') + this.errorMessage,
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.isLoading = false
      }
    },
    async uploadS3() {
      try {
        if (this.chLogo) {
          // userPicture S3 업로드
          let parallellUploads = await setFileUpload(this, this.chLogo, 'chLogo', this.chId)
          parallellUploads.on('httpUploadProgress', () => {
            // ctx.progressValue = Math.floor(100 / (progress.total / progress.loaded))
            // console.log('progress ', progress)
          })
          // if (parallellUploads.params.ContentType.indexOf('image') < 0) return
          // S3 Upload
          await parallellUploads.done()
          // Cloud Front 캐시 삭제
          await setInvalidCache(this, `/chLogo/${this.chId}.png`)
        }
      } catch (err) {
        this.errorMessage = err
      }
    },
    deleteChLogo() {
      this.chLogo = null
      this.isChLogoChanged = true
    },
    setChLogo(e) {
      // TODO: 모달창으로 설정하도록 변경 필요
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
      e.target.value = ''
    },
    createImage(file) {
      var reader = new FileReader()
      reader.onload = async (e) => {
        this.chLogo = await this.resizeImage(e.target.result)
        this.isChLogoChanged = true
      }
      reader.readAsDataURL(file)
    },
    // TODO: common library로 이동
    resizeImage(base64Str, maxWidth = 160, maxHeight = 160) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
  },
  computed: {
    ...mapGetters([
      'selectedWsInfo',
      'selectedCh',
      'currentMt',
      'currentClip',
      'userInfo',
      'isMtOrganizer',
      'isWsManager',
      'isWsOwner',
    ]),
    chId() {
      return this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`
    },
    isMobile() {
      return isMobile()
    },
    isSafari() {
      return isSafari()
    },
  },
}
</script>

<style scoped>
.txt-dialog-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.btn-small >>> span {
  font-size: 12px;
  font-weight: 400 !important;
}
.filebox label {
  display: inline-block;
  padding: 10.8px 24.1px;
  color: white;
  font-size: 12px;
  line-height: normal;
  vertical-align: middle;
  background-color: #272727;
  cursor: pointer;
  border-radius: 4px;
}
.filebox input[type='file'] {
  /* 파일 필드 숨기기 */
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}
.avatar-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
</style>
